export default "__VITE_ASSET__D_nxLVmr__"